// exportProfileContent.js
import * as XLSX from "xlsx";

const getLanguages = (profileData) => {
  const langSet = new Set();
  ["advanced", "dynamic", "compact"].forEach((reportType) => {
    const reportData = profileData[reportType];
    if (!reportData) return;

    const about = reportData.about;
    const tipsGroups = reportData.tips || [];

    if (about?.header) Object.keys(about.header).forEach((lang) => langSet.add(lang));
    if (about?.text) Object.keys(about.text).forEach((lang) => langSet.add(lang));

    tipsGroups.forEach((tipsGroup) => {
      if (tipsGroup.header) Object.keys(tipsGroup.header).forEach((lang) => langSet.add(lang));
      if (tipsGroup.subHeader) Object.keys(tipsGroup.subHeader).forEach((lang) => langSet.add(lang));
      (tipsGroup.tipsArray || []).forEach((tip) => {
        if (tip.text) Object.keys(tip.text).forEach((lang) => langSet.add(lang));
      });
    });
  });

  const languages = Array.from(langSet);
  return languages.length > 0 ? languages : ["en"];
};

const transformJsonToReducedRows = (json) => {
  const rows = [];
  const allLangs = new Set();
  Object.values(json).forEach(profileData => {
    getLanguages(profileData).forEach(lang => allLangs.add(lang));
  });
  
  const languages = Array.from(allLangs).length > 0 ? Array.from(allLangs) : ["en"];

  Object.entries(json).forEach(([profileName, profileData]) => {
    
    if (profileData.others) {
      rows.push({
        "Profile Name": profileName,
        "Report Type": "others",
        "Language": "",
        "Href": profileData.others.href || "",
      });
    }

    ["advanced", "dynamic", "compact"].forEach((reportType) => {
      const reportData = profileData[reportType];
      if (!reportData) return;

      const about = reportData.about;
      const tipsGroups = reportData.tips || [];

      languages.forEach((lang) => {
        
        // Add ONE ROW for 'About' info
        rows.push({
          "Profile Name": profileName,
          "Report Type": reportType,
          "Language": lang,
          "About_Header": about?.header?.[lang] || "",
          "About_Text": about?.text?.[lang] || "",
        });

        // Add SEPARATE rows for each tip
        tipsGroups.forEach((tipsGroup) => {
          
          // --- THIS IS THE FIX ---
          // Create a language-independent key for the group
          const tipGroupHeaderID = tipsGroup.header?.en || "";
          const tipGroupSubHeaderID = tipsGroup.subHeader?.en || "";
          // --- END OF FIX ---

          (tipsGroup.tipsArray || []).forEach((tip) => {
            // Only add a row if the text for that language exists
            if (tip.text && tip.text.hasOwnProperty(lang)) {
              rows.push({
                "Profile Name": profileName,
                "Report Type": reportType,
                "Language": lang,
                // Add the new Group ID columns
                "Tip_Group_Header_ID": tipGroupHeaderID,
                "Tip_Group_SubHeader_ID": tipGroupSubHeaderID,
                // Add the translated headers
                "Tips_Header": tipsGroup.header?.[lang] || "",
                "Tips_Subheader": tipsGroup.subHeader?.[lang] || "",
                "Tip_Text": tip.text?.[lang] || "",
                "Tip_Icon": tip.svg || "",
              });
            }
          });
        });
      });
    });
  });

  return rows;
};

const handleExport = (contentJson) => {
  if (!contentJson) {
    console.log("No content to export");
    return;
  }
  try {
    const data = transformJsonToReducedRows(contentJson);
    
    const headers = [
      "Profile Name", "Report Type", "Language",
      "About_Header", "About_Text",
      // --- THIS IS THE FIX ---
      // Add the new ID columns to the header
      "Tip_Group_Header_ID", "Tip_Group_SubHeader_ID",
      // --- END OF FIX ---
      "Tips_Header", "Tips_Subheader", "Tip_Text", "Tip_Icon",
      "Href"
    ];

    const worksheet = XLSX.utils.json_to_sheet(data, { header: headers });
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Profile Content");
    XLSX.writeFile(workbook, "profile_content.xlsx");
  } catch (error) {
    console.error("Error during export:", error);
  }
};

export default handleExport;